var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.061,
    height: 16.707
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Left Small"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 904",
    d: "M8.707.355l-8 8 8 8",
    fill: "none",
    stroke: "#00074c"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI5LjA2MSIgaGVpZ2h0PSIxNi43MDciIHZpZXdCb3g9IjAgMCA5LjA2MSAxNi43MDciPgogIDxnIGlkPSJMZWZ0X1NtYWxsIiBkYXRhLW5hbWU9IkxlZnQgU21hbGwiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuNzA3IDAuMzU0KSI+CiAgICA8cGF0aCBpZD0iUGF0aF85MDQiIGRhdGEtbmFtZT0iUGF0aCA5MDQiIGQ9Ik0yMy4zMzMsNy4zMzRsLTgsOCw4LDgiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xNS4zMzMgLTcuMzMzKSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDAwNzRjIiBzdHJva2Utd2lkdGg9IjEiLz4KICA8L2c+Cjwvc3ZnPgo=";
export { SvgLeftSmall as ReactComponent };